import { api } from "./axiosConfig";
import CandidateAPI from "./CandidateService";

const getLocal = () => window.ConnectorDynamicSearchArgs?.folder ?? "uk";
const getOrganisation = () =>
  window.ConnectorDynamicSearchArgs?.organisation ?? "";

export const JobSearchAPI = {
  search: async function (searchRequest) {
    const response = await api.request({
      url: `/job-search?local=${getLocal()}&organisation=${getOrganisation()}`,
      method: "POST",
      data: JSON.stringify({
        ...searchRequest,
        pageSize: 50,
      }),
    });

    localStorage.setItem("uid", response.data.uid);
    sessionStorage.setItem("sid", response.data.sid);

    try {
      await CandidateAPI.setBookmarkFalg(response);
    } catch (err) {
      console.error(err);
    }

    return response.data;
  },

  filters: async function () {
    const response = await api.request({
      url: `/filter?local=${getLocal()}`,
      method: "GET",
    });

    return response.data;
  },

  details: async function (jobId, jobSlug) {
    const response = await api.request({
      url: jobId > 0 ? `/job-details?jobId=${jobId}&local=${getLocal()}&organisation=${getOrganisation()}`
        : `/job-details?jobSlug=${jobSlug}&local=${getLocal()}&organisation=${getOrganisation()}`,
      method: "GET"
    });

    if(response && response.status === 200)
    {
      return response.data;
    }

    return null;
  },

  details_metas: async function (jobId, jobSlug) {
    const response = await api.request({
      url: jobId > 0 ? `/job-details/metas?jobId=${jobId}&local=${getLocal()}&organisation=${getOrganisation()}`
        : `/job-details/metas?jobSlug=${jobSlug}&local=${getLocal()}&organisation=${getOrganisation()}`,
      method: "GET"
    });

    if(response && response.status === 200)
    {
      return response.data;
    }

    return null;
  },  
};

export default JobSearchAPI;
